import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

import { VACATION_BID_TEST_ID } from "../testIds";

export interface IAwardingConfirm {
  title: string;
  /** One statement per line describing what confirming will do. */
  lines: string[];
  confirmLabel: string;
  onConfirm: () => void;
}

export interface IAwardingConfirmDialogProps {
  confirm: IAwardingConfirm | null;
  onClose: () => void;
}

/** Asks before an awarding action that needs a second look. Open whenever `confirm` is set. */
export const AwardingConfirmDialog = (props: IAwardingConfirmDialogProps): JSX.Element => {
  const { confirm, onClose } = props;

  return (
    <Dialog open={!!confirm} onClose={onClose} data-testid={VACATION_BID_TEST_ID.awardingConfirmDialog}>
      <DialogTitle>{confirm?.title}</DialogTitle>
      <DialogContent>
        {(confirm?.lines ?? []).map((line) => (
          <Typography key={line} variant="body2" sx={{ marginBottom: "6px" }}>
            {line}
          </Typography>
        ))}
      </DialogContent>
      <DialogActions>
        <Button
          size="small"
          variant="contained"
          color="secondary"
          onClick={onClose}
          data-testid={VACATION_BID_TEST_ID.awardingCancelButton}
        >
          Cancel
        </Button>
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={() => {
            confirm?.onConfirm();
            onClose();
          }}
          data-testid={VACATION_BID_TEST_ID.awardingConfirmButton}
        >
          {confirm?.confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AwardingConfirmDialog;
